// src/pages/AllSellersPage.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const AllSellersPage = () => {
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();


  
 // 🔹 Navigate to Seller Shop Page
  const openSellerShop = (seller) => {
    if (!seller) return;
    navigate(`/shopbuyeformarketplace?sellerId=${seller.id}`);
  };
   useEffect(() => {
     const fetchSellers = async () => {
       setLoading(true);
       setError(null);
 
       try {
         const token =
           sessionStorage.getItem("accessToken") ||
           localStorage.getItem("accessToken");
 
         if (!token) {
           setError("Authentication token missing. Please log in.");
           setLoading(false);
           return;
         }
 
         const response = await fetch(
           `${API_BASE_URL}/seller/get-sellers`,
           {
             method: "POST",
             headers: {
               "Content-Type": "application/json",
               token: token,
             },
             body: JSON.stringify({
               filters: {},
               page: 1,
               limit: 10,
             }),
           }
         );
 
         const data = await response.json();
 
         if (
           response.ok &&
           data.success &&
           Array.isArray(data.result?.sellers)
         ) {
           setSellers(data.result.sellers);
         } else {
           setError(data?.message || "Failed to load sellers.");
         }
       } catch (err) {
         console.error("Error fetching sellers:", err);
         setError("Failed to load sellers.");
       } finally {
         setLoading(false);
       }
     };
 
     fetchSellers();
   }, []);
 

  if (loading) return <p className="p-6 text-gray-600">Loading sellers...</p>;
  if (error) return <p className="p-6 text-red-600">{error}</p>;

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-2xl font-bold mb-6 text-gray-800">All Sellers</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {sellers.map((seller) => (
          <div
            key={seller.id}
                        onClick={() => openSellerShop(seller)}

            className="bg-white p-4 rounded-lg shadow hover:shadow-lg transition"
          >
            <img
              src={seller.profile_image?.url || require("../../assets/profile.png")}
              alt={seller.name}
              className="w-full h-40 object-cover rounded-lg mb-3"
            />
            <h3 className="font-semibold text-lg text-gray-800">
              {seller.store_name}
            </h3>
            <p className="text-sm text-gray-500 line-clamp-2">
              {seller.store_description || "No description available"}
            </p>

            {/* Product Images */}
            <div className="flex -space-x-3 mt-3">
              {seller.product_images?.length > 0 ? (
                seller.product_images.slice(0, 4).map((img, index) => (
                  <img
                    key={index}
                    src={img.url}
                    className="w-8 h-8 rounded-full border-2 border-white shadow-md object-cover"
                  />
                ))
              ) : (
                <img
                  src="/image/PostInputImage.png"
                  className="w-8 h-8 rounded-full border-2 border-white shadow-md"
                />
              )}
            </div>

            {/* Total Products */}
            <div className="mt-2 text-green-700 font-semibold text-sm">
              {seller.total_products
                ? `${seller.total_products} Products`
                : "No Products"}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllSellersPage;
